import React, {useEffect, useRef, useState} from 'react';
import './index.css';
import TabSection from '../../components/tabsection/index';
import {Trans, useTranslation} from 'react-i18next';
import {history} from '../../../../utils/redux/store';
import _get from 'lodash/get';
import {Field, Form, Formik} from 'formik';
import RadioButton from '../../../../components/formik/RadioButton';
import ColorField from '../../../../components/product/color/colorfield';
import SelectBox from '../../../../components/formik/SelectBox';
import skinResultPageStyle from '../../../../utils/config/skinResultPageStyle';
import ImageField from '../../../../components/formik/ImageField';
import CustomSwitch from '../../../../components/layout/CustomSwitch';
import InputBox from '../../../../components/formik/InputBox';
import DraftEditor from '../../../../components/formik/DraftEditor';
import {useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import Header from '../../components/header';
import PreviewModule from '../../components/previewmodule';
import ButtonWithRestoreGroup from '../../../../components/formik/ButtonWithRestoreGroup';
import {
  getTemplateDefaultConfig,
  getBrandId,
  handleImage,
  zipGenerate,
  getTemplateLayout,
  getTemplate,
  updateTemplate,
} from '../../../../utils/skincareUtils';
import templateConfigs from '../config/utils/templateUtils';
import Loader from '../../../../components/spinner/Loader';
import UnSavedModal from '../../components/unSavedModal';
import classnames from 'classnames';
import useWindowWidth from '../../../../components/hook/useWindowWidth';
import Select from 'react-select';
import cookieUtils from '../../../../utils/cookieUtils';
import smbUtils from '../../../../utils/smbUtils';
import PublishToOnlineModal from '../components/PublishToOnlineModal';
import {privilegeUtils} from '../../../../utils/privilegeUtils';
import langUtils from '../../../../utils/langUtils';

export default function GetSkinResult() {
  const width = useWindowWidth();
  const [initValue, setInitValue] = useState({});
  const auth = useSelector(state => state.components.auth.accountSummary);
  const {token, customerId, brandInfo} = smbUtils.customerInfo(auth);
  const [revisionId, setRevisionId] = useState();
  const [template, setTemplate] = useState();
  const [templateType, setTemplateType] = useState('GetResult');
  const [templateId, setTemplateId] = useState('');
  const formRef = useRef();
  const {t} = useTranslation();
  const [previewUrl, setPreviewUrl] = useState('');
  const [publishStatus, setPublishStatus] = useState(false);
  const [isShowPublishModal, setIsShowPublishModal] = useState(false);
  const [theme, setTheme] = useState('');
  const [isLoaded, setIsLoaded] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [lightData, setLightData] = useState();
  const [darkData, setDarkData] = useState();
  const [isFirst, setIsFirst] = useState(true);
  const [hidePreview, setHidePreview] = useState(false);
  const appLang = langUtils
    .getAppLangList()
    .find(l => l.value === cookieUtils.getCookie('appLang'));
  useEffect(() => {
    if (_get(brandInfo, 'templateVersion') === 2) {
      history.push('/skincare-pro/ui-configuration/skin-result');
    }
    getBrandId(token, customerId).then(res => {
      if (res && _get(res, 'getResultRvId', '')) {
        setRevisionId(_get(res, 'getResultRvId', ''));
      }
    });
  }, []);

  const handleRestore = mode => {
    getTemplateDefaultConfig(
      'SmbGetResult',
      mode.replace(mode[0], mode[0].toUpperCase()),
      1,
      customerId
    ).then(r => {
      if (r && r.templateMetadata && r.fileId) {
        let data = r.templateMetadata;
        setTemplate(data);
        setInitValue(data.langs[0].page);
        updateTemplate(
          token,
          customerId,
          templateId,
          templateType,
          data,
          r.fileId
        ).then(r => {
          setPublishStatus(!publishStatus);
          toast.success(
            <Trans i18nKey="c.f.simple.button.group.success">success</Trans>
          );
        });
      }
    });
  };

  useEffect(() => {
    if (revisionId) {
      getTemplateLayout(
        token,
        customerId,
        'SmbSkincareResultPage',
        _get(brandInfo, 'templateVersion')
      ).then(res => {
        if (res) {
          setPreviewUrl(res.getPhotoPage);
        }
      });

      getTemplate(token, customerId, revisionId, templateType)
        .then(res => {
          if (res && res.metaDataJson) {
            let data = JSON.parse(res.metaDataJson);
            setTemplate(JSON.parse(res.metaDataJson));
            setInitValue(data.langs[0].page);
            setTheme(data.langs[0].page.featureConfig.getPhoto.templateStyle);
          }
          setTemplateId(_get(res, 'templateId', ''));
          setTemplateType(_get(res, 'templateType', ''));
        })
        .then(() => setIsLoaded(false));
    }
  }, [revisionId]);

  const getInitValue = values => {
    const v = values || {};
    return {
      ...v,
      featureConfig: {
        ..._get(v, 'featureConfig'),
        getPhoto: {
          ..._get(v, 'featureConfig.getPhoto'),
          qrCode: {
            ..._get(v, 'featureConfig.getPhoto.qrCode'),
            descLanguage: appLang || {label: 'English', value: 'enu'},
            descI18n: _get(v, 'featureConfig.getPhoto.qrCode.descI18n') || {
              enu: `<span style="font-size: 16px;color: #000000;">Scan QR Code To Get Skin Report On Your Phone.</span>`,
              fra: `<span style="font-size: 16px;color: #000000;">Scannez le QR code pour obtenir le rapport de sa peau sur son téléphone.</span>`,
              jpn: `<span style="font-size: 16px;color: #000000;">QRコードを読み取ると、スマホの画面に肌分析レポートが表示されます。</span>`,
              kor: `<span style="font-size: 16px;color: #000000;">QR 코드를 스캔하여 스마트폰으로 피부 보고서를 받아보세요.</span>`,
              deu: `<span style="font-size: 16px;color: #000000;">Scannen Sie den QR Code um die Hautanalyse zu erhalten</span>`,
              esp: `<span style="font-size: 16px;color: #000000;">Escanea el código QR para obtener el informe de tu piel en tu teléfono.</span>`,
              ita: `<span style="font-size: 16px;color: #000000;">Scansiona il Codice QR per Ottenere il Rapporto Pelle sul Tuo Smartphone.</span>`,
            },
            title: {
              ..._get(v, 'featureConfig.getPhoto.qrCode.title'),
              textLanguage: appLang || {label: 'English', value: 'enu'},
              textI18n: _get(
                v,
                'featureConfig.getPhoto.qrCode.title.textI18n'
              ) || {
                enu: `<span><span style="color: #6fbaff;font-size: 24px;"><strong>Get Skin Report via QR Code:</strong></span></span>`,
                fra: `<span><span style="color: #6fbaff;font-size: 24px;"><strong>Obtenir le rapport de sa peau grâce à un QR code :</strong></span></span>`,
                jpn: `<span><span style="color: #6fbaff;font-size: 24px;"><strong>QRコードをスキャンして肌分析レポートを入手</strong></span></span>`,
                kor: `<span><span style="color: #6fbaff;font-size: 24px;"><strong>QR 코드로 피부 보고서 받기:</strong></span></span>`,
                deu: `<span><span style="color: #6fbaff;font-size: 24px;"><strong>Hautanalyse per OR Code erhalten</strong></span></span>`,
                esp: `<span><span style="color: #6fbaff;font-size: 24px;"><strong>Obten el resultado de tu piel a través del código QR:</strong></span></span>`,
                ita: `<span><span style="color: #6fbaff;font-size: 24px;"><strong>Ottieni il Rapporto Pelle tramite Codice QR:</strong></span></span>`,
              },
            },
          },
          email: {
            ..._get(v, 'featureConfig.getPhoto.email'),
            sendButton: {
              ..._get(v, 'featureConfig.getPhoto.email.sendButton'),
              textLanguage: appLang || {label: 'English', value: 'enu'},
              textI18n: _get(
                v,
                'featureConfig.getPhoto.email.sendButton.textI18n'
              ) || {
                enu: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Send</strong></span></span>`,
                fra: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Envoyer</strong></span></span>`,
                jpn: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>送信</strong></span></span>`,
                kor: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>보내기</strong></span></span>`,
                deu: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Absenden</strong></span></span>`,
                esp: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Enviar</strong></span></span>`,
                ita: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Invia</strong></span></span>`,
              },
            },
            inputFieldLanguage: appLang || {label: 'English', value: 'enu'},
            inputFieldI18n: _get(
              v,
              'featureConfig.getPhoto.email.inputFieldI18n'
            ) || {
              enu: 'Enter your E-mail',
              fra: 'Saisissez votre adresse email',
              jpn: 'メール アドレスを入力',
              kor: '이메일 입력',
              deu: 'Geben Sie Ihre E-Mail-Adresse ein',
              esp: 'Introduzca su correo electrónico',
              ita: "Inserisci l'e-mail",
            },
            title: {
              ..._get(v, 'featureConfig.getPhoto.email.title'),
              textLanguage: appLang || {label: 'English', value: 'enu'},
              textI18n: _get(
                v,
                'featureConfig.getPhoto.email.title.textI18n'
              ) || {
                enu: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Get Skin Report via E-mail:</strong></span></span>`,
                fra: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Obtenir le rapport de sa peau par email:</strong></span></span>`,
                jpn: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Eメールで肌分析レポートを入手</strong></span></span>`,
                kor: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>이메일로 스킨 보고서 받기:</strong></span></span>`,
                deu: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Hautanalyse per Email erhalten</strong></span></span>`,
                esp: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Obten resultado en correo</strong></span></span>`,
                ita: `<span><span style="color: rgb(111,186,255);font-size: 24px;"><strong>Ottieni il Rapporto Pelle tramite e-Mail:</strong></span></span>`,
              },
            },
          },
        },
      },
    };
  };

  const formikConfig = {
    enableReinitialize: true,
    initialValues: getInitValue(initValue),
    onSubmit: async (values, {setSubmitting, resetForm}) => {
      setSubmitting(true);
      const processedData = {
        ...values,
        featureConfig: {
          ..._get(values, 'featureConfig'),
          getPhoto: {
            ..._get(values, 'featureConfig.getPhoto'),
            header: {
              backgroundColor: _get(
                values,
                'featureConfig.getPhoto.header.backgroundColor'
              ),
              borderBottom: {
                width: _get(
                  values,
                  'featureConfig.getPhoto.header.borderBottom.width'
                ),
                style: _get(
                  values,
                  'featureConfig.getPhoto.header.borderBottom.style'
                ),
                color: _get(
                  values,
                  'featureConfig.getPhoto.header.borderBottom.color'
                ),
              },
              backIcon: {
                enabled: true,
                type: 'custom',
                image: {
                  id: '',
                  url: await handleImage(
                    _get(
                      values,
                      'featureConfig.getPhoto.header.backIcon.image.image'
                    ),
                    token,
                    customerId
                  ),
                  image: await handleImage(
                    _get(
                      values,
                      'featureConfig.getPhoto.header.backIcon.image.image'
                    ),
                    token,
                    customerId
                  ),
                },
              },
              homeIcon: {
                enabled: true,
                type: 'custom',
                image: {
                  id: '',
                  url: await handleImage(
                    _get(
                      values,
                      'featureConfig.getPhoto.header.homeIcon.image.image'
                    ),
                    token,
                    customerId
                  ),
                  image: await handleImage(
                    _get(
                      values,
                      'featureConfig.getPhoto.header.homeIcon.image.image'
                    ),
                    token,
                    customerId
                  ),
                },
              },
            },
          },
        },
      };

      const data = {
        ...template,
        langs: [
          {
            ...template.langs[0],
            page: processedData,
          },
        ],
      };
      templateConfigs
        .toResultZip(data)
        .then(async r => {
          setTimeout(async () => {
            const fileId = await zipGenerate(
              r,
              'ResultPage',
              token,
              customerId,
              [
                {
                  fileName: 'result_back.jpg',
                  file: data.langs[0].page.header.backIcon.image.url,
                },
                {
                  fileName: 'result_home.jpg',
                  file: data.langs[0].page.header.homeIcon.image.url,
                },
                {
                  fileName: 'get_result_back.jpg',
                  file:
                    data.langs[0].page.featureConfig.getPhoto.header.backIcon
                      .image.url,
                },
                {
                  fileName: 'get_result_home.jpg',
                  file:
                    data.langs[0].page.featureConfig.getPhoto.header.homeIcon
                      .image.url,
                },
              ]
            );
            await updateTemplate(
              token,
              customerId,
              templateId,
              templateType,
              data,
              fileId
            )
              .then(r => setIsShowPublishModal(true))
              .catch(r => {
                toast.error(
                  <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
                );
                setSubmitting(false);
              });
          }, 1000);
        })
        .catch(r => {
          toast.error(
            <Trans i18nKey="c.f.simple.button.group.failed">failed</Trans>
          );
          setSubmitting(false);
        });
    },
  };

  const handleOnChange = () => {
    if (!formRef.current) {
      return;
    }
    const formData = formRef.current.state.values;
    const style = _get(formData, 'featureConfig.getPhoto.templateStyle');
    if (style && style !== theme) {
      if (isFirst) {
        if (style === 'dark') {
          setLightData(formData);
        } else {
          setDarkData(formData);
        }
        setDefault(style);
        setTheme(style);
        setIsFirst(false);
      } else {
        setTheme(style);
        setShowDialog(true);
      }
    }
  };

  const changeTheme = (style, value, setValues, setFieldValue) => {
    setHidePreview(true);
    if (style === 'dark') {
      setLightData(value);
      if (darkData) {
        setValues(darkData);
        setFieldValue('featureConfig.getPhoto.templateStyle', style);
        setShowDialog(false);
      } else {
        setDefault(style);
      }
    } else {
      setDarkData(value);
      if (lightData) {
        setValues(lightData);
        setFieldValue('featureConfig.getPhoto.templateStyle', style);
        setShowDialog(false);
      } else {
        setDefault(style);
      }
    }
    setTimeout(() => {
      setHidePreview(false);
    }, 200);
  };

  const setDefault = style => {
    setHidePreview(true);
    getTemplateDefaultConfig(
      'SmbGetResult',
      style.replace(style[0], style[0].toUpperCase()),
      1,
      customerId
    ).then(r => {
      if (r && r.templateMetadata) {
        let data = r.templateMetadata;
        setTemplate(data);
        setInitValue(data.langs[0].page);
        setShowDialog(false);
        setTimeout(() => {
          setHidePreview(false);
        }, 200);
      }
    });
  };

  if (
    !(
      privilegeUtils.canUiConfig(auth) ||
      privilegeUtils.isTechnicalSupport(auth)
    )
  ) {
    history.push('/');
  }

  return isLoaded ? (
    <div>
      <Header />
      <Loader />
    </div>
  ) : (
    <Formik {...formikConfig} ref={formRef}>
      {formikProps => (
        <Form
          className="skincare-configuration-form"
          onChange={() => {
            setTimeout(() => {
              handleOnChange();
            });
          }}
        >
          <Header publishStatus={publishStatus} dirty={formikProps.dirty} />
          <div
            className="skincare-configuration-layout"
            style={{height: 'calc(100% - 170px)'}}
          >
            <div className="skincare-configuration-layout__left">
              <TabSection dirty={formikProps.dirty} />
              <div className="kt-portlet skincare-configuration-layout__left-portlet">
                <div className="kt-portlet__body skincare-configuration-layout__left-portlet__body">
                  <div>
                    <h5>
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.theme">
                        Get Skin Result Page Theme
                      </Trans>
                      <div
                        className="kt-margin-t-10"
                        style={{
                          backgroundColor: '#e1e1ef',
                          height: '1px',
                        }}
                      />
                    </h5>
                    <div className="form-group row">
                      {width >= 1366 && (
                        <label className="col-3 col-form-label text-left" />
                      )}
                      <div
                        className={classnames({
                          'col-6': width < 1366,
                          'col-3': width >= 1366,
                        })}
                      >
                        <Field
                          name="featureConfig.getPhoto.templateStyle"
                          label={
                            <Trans i18nKey="p.s.uiconfiguration.getskinresult.template.light">
                              Light
                            </Trans>
                          }
                          value={'light'}
                          component={RadioButton}
                        />
                        <img
                          src={require('../../../../assets/images/skincare/skincarepro_v1_16share_max.png')}
                          alt={''}
                          width={'inherit'}
                          style={{width: '90%', boxShadow: '0 0 5px'}}
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width < 1366,
                          'col-3': width >= 1366,
                        })}
                      >
                        <Field
                          name="featureConfig.getPhoto.templateStyle"
                          label={
                            <Trans i18nKey="p.s.uiconfiguration.getskinresult.template.dark">
                              Dark
                            </Trans>
                          }
                          value={'dark'}
                          component={RadioButton}
                        />
                        <img
                          src={require('../../../../assets/images/skincare/skincarepro_v1_dk_10share_btn_activated.png')}
                          alt={''}
                          style={{width: '90%', boxShadow: '0 0 5px'}}
                        />
                      </div>
                    </div>
                    <h5>
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.page.header">
                        Page Header
                      </Trans>
                      <div
                        className="kt-margin-t-10"
                        style={{
                          backgroundColor: '#e1e1ef',
                          height: '1px',
                        }}
                      />
                    </h5>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.getskinresult.background.color">
                          Background Color
                        </Trans>
                      </label>
                      <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                        <Field
                          name="featureConfig.getPhoto.header.backgroundColor"
                          component={ColorField}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.getskinresult.bottom.border">
                          Bottom Border
                        </Trans>
                      </label>
                      <div
                        className="col-9 col-lg-8 col-md-8"
                        style={{display: width > 1366 ? 'flex' : 'block'}}
                      >
                        <div
                          className={classnames({
                            'col-3': width >= 1366,
                            'col-9': width < 1366,
                            'kt-margin-b-20': width < 1366,
                          })}
                        >
                          <Field
                            name="featureConfig.getPhoto.header.borderBottom.color"
                            component={ColorField}
                          />
                        </div>
                        <div
                          className={classnames({
                            'col-3': width >= 1366,
                            'col-9': width < 1366,
                            'kt-margin-b-20': width < 1366,
                          })}
                        >
                          <Field
                            name="featureConfig.getPhoto.header.borderBottom.width"
                            component={SelectBox}
                            options={skinResultPageStyle.getBorderWidthConfigs()}
                          />
                        </div>
                        <div
                          className={classnames({
                            'col-3': width >= 1366,
                            'col-9': width < 1366,
                            'kt-margin-b-20': width < 1366,
                          })}
                        >
                          <Field
                            name="featureConfig.getPhoto.header.borderBottom.style"
                            component={SelectBox}
                            options={skinResultPageStyle.getBorderStyleConfigs()}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.getskinresult.back.icon">
                          Back Icon
                        </Trans>
                      </label>
                      <div className="col-4">
                        <Field
                          name="featureConfig.getPhoto.header.backIcon.image.image"
                          imageUrl={_get(
                            formikProps.values,
                            'featureConfig.getPhoto.header.backIcon.image.image'
                          )}
                          scaleImage={true}
                          clearFormFields={[
                            'featureConfig.getPhoto.header.backIcon.image.image',
                            'featureConfig.getPhoto.header.backIcon.image.url',
                          ]}
                          component={ImageField}
                          width={200}
                          height={200}
                          maxWidth={width > 1024 ? 200 : 100}
                          maxHeight={width > 1024 ? 200 : 100}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                        <Trans i18nKey="p.s.uiconfiguration.getskinresult.home.icon">
                          Home Icon
                        </Trans>
                      </label>
                      <div className="col-4">
                        <Field
                          name="featureConfig.getPhoto.header.homeIcon.image.image"
                          imageUrl={_get(
                            formikProps.values,
                            'featureConfig.getPhoto.header.homeIcon.image.image'
                          )}
                          scaleImage={true}
                          clearFormFields={[
                            'featureConfig.getPhoto.header.homeIcon.image.image',
                            'featureConfig.getPhoto.header.homeIcon.image.url',
                          ]}
                          component={ImageField}
                          width={200}
                          height={200}
                          maxWidth={width > 1024 ? 200 : 100}
                          maxHeight={width > 1024 ? 200 : 100}
                        />
                      </div>
                    </div>
                  </div>
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.body">
                      Body
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.background.color">
                        Background Color
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                      <Field
                        name="featureConfig.getPhoto.body.backgroundColor"
                        component={ColorField}
                      />
                    </div>
                  </div>
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.skin.detection.result.photo">
                      Detection Result Photo
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.photo.size">
                        Photo Size
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-3' : 'col-6'}>
                      <Field
                        name="featureConfig.getPhoto.tryOnPhoto.width"
                        component={InputBox}
                        type="number"
                        min={50}
                        max={100}
                        onBlur={value => {
                          let size = value;
                          if (value > 100) size = 100;
                          if (value < 50) size = 50;
                          formikProps.setFieldValue(
                            `featureConfig.getPhoto.tryOnPhoto.width`,
                            size
                          );
                        }}
                      />
                    </div>
                    <div className="d-flex" style={{margin: 'auto 0'}}>
                      %
                    </div>
                  </div>
                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.skin.report.qrcode">
                      Skin Report (QR code)
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <h6 className="kt-margin-t-10">
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.skin.qrcode">
                      QR Code
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.show">
                        Show
                      </Trans>
                    </label>
                    <div className="col-9 col-lg-8 col-md-8">
                      <Field
                        name="featureConfig.getPhoto.qrCode.enabled"
                        value={_get(
                          formikProps.values,
                          'featureConfig.getPhoto.qrCode.enabled'
                        )}
                        component={CustomSwitch}
                      />
                    </div>
                  </div>
                  <h6>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.background">
                      Background
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.background.color">
                        Background Color
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                      <Field
                        name="featureConfig.getPhoto.qrCode.title.backgroundColor"
                        component={ColorField}
                      />
                    </div>
                  </div>
                  <h6>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.title">
                      Title
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.title.text">
                        Title Text
                      </Trans>
                    </label>
                    <div
                      className="col-9 col-lg-8 col-md-8 row"
                      style={{display: width >= 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Select
                          options={langUtils.getAppLangList()}
                          onChange={o => {
                            formikProps.setFieldValue(
                              'featureConfig.getPhoto.qrCode.title.textLanguage',
                              o
                            );
                          }}
                          value={_get(
                            formikProps.values,
                            'featureConfig.getPhoto.qrCode.title.textLanguage'
                          )}
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Field
                          name={`featureConfig.getPhoto.qrCode.title.textI18n.${_get(
                            formikProps.values,
                            'featureConfig.getPhoto.qrCode.title.textLanguage.value'
                          )}`}
                          id="description"
                          component={DraftEditor}
                          toolbarOnFocus={true}
                          containerStyle={{}}
                          editorClassname={'skin-res--editor'}
                        />
                      </div>
                    </div>
                  </div>
                  <h6>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.description">
                      Description
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.description.text">
                        Description Text
                      </Trans>
                    </label>
                    <div
                      className="col-9 col-lg-8 col-md-8 row"
                      style={{display: width >= 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Select
                          options={langUtils.getAppLangList()}
                          onChange={o => {
                            formikProps.setFieldValue(
                              'featureConfig.getPhoto.qrCode.descLanguage',
                              o
                            );
                          }}
                          value={_get(
                            formikProps.values,
                            'featureConfig.getPhoto.qrCode.descLanguage'
                          )}
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Field
                          name={`featureConfig.getPhoto.qrCode.descI18n.${_get(
                            formikProps.values,
                            'featureConfig.getPhoto.qrCode.descLanguage.value'
                          )}`}
                          id="description"
                          component={DraftEditor}
                          toolbarOnFocus={true}
                          containerStyle={{}}
                          editorClassname={'skin-res--editor'}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.description.text.color">
                        Description Text Color
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                      <Field
                        name="featureConfig.getPhoto.qrCode.descColor"
                        component={ColorField}
                      />
                    </div>
                  </div>

                  <h5>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.skin.report.email">
                      Skin Report (Email)
                    </Trans>
                    <div
                      className="kt-margin-t-10"
                      style={{
                        backgroundColor: '#e1e1ef',
                        height: '1px',
                      }}
                    />
                  </h5>
                  <h6 className="kt-margin-t-10">
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.email">
                      E-mail
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.show">
                        Show
                      </Trans>
                    </label>
                    <div className="col-9 col-lg-8 col-md-8">
                      <Field
                        name="featureConfig.getPhoto.email.enabled"
                        value={_get(
                          formikProps.values,
                          'featureConfig.getPhoto.email.enabled'
                        )}
                        component={CustomSwitch}
                      />
                    </div>
                  </div>
                  <h6>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.background">
                      Background
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.background.color">
                        Background Color
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                      <Field
                        name="featureConfig.getPhoto.email.title.backgroundColor"
                        component={ColorField}
                      />
                    </div>
                  </div>
                  <h6>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.title">
                      Title
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.title.text">
                        Title Text
                      </Trans>
                    </label>
                    <div
                      className="col-9 col-lg-8 col-md-8 row"
                      style={{display: width >= 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Select
                          options={langUtils.getAppLangList()}
                          onChange={o => {
                            formikProps.setFieldValue(
                              'featureConfig.getPhoto.email.title.textLanguage',
                              o
                            );
                          }}
                          value={_get(
                            formikProps.values,
                            'featureConfig.getPhoto.email.title.textLanguage'
                          )}
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Field
                          name={`featureConfig.getPhoto.email.title.textI18n.${_get(
                            formikProps.values,
                            'featureConfig.getPhoto.email.title.textLanguage.value'
                          )}`}
                          id="description"
                          component={DraftEditor}
                          toolbarOnFocus={true}
                          containerStyle={{}}
                          editorClassname={'skin-res--editor'}
                        />
                      </div>
                    </div>
                  </div>
                  <h6>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.address.input.field">
                      Address Input Field
                    </Trans>
                  </h6>
                  <div className="form-group row">
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.input.field.text">
                        Input Field Text
                      </Trans>
                    </label>
                    <div
                      className="col-9 col-lg-8 col-md-8 row"
                      style={{display: width > 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Select
                          options={langUtils.getAppLangList()}
                          onChange={o => {
                            formikProps.setFieldValue(
                              'featureConfig.getPhoto.email.inputFieldLanguage',
                              o
                            );
                          }}
                          value={_get(
                            formikProps.values,
                            'featureConfig.getPhoto.email.inputFieldLanguage'
                          )}
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Field
                          name={`featureConfig.getPhoto.email.inputFieldI18n.${_get(
                            formikProps.values,
                            'featureConfig.getPhoto.email.inputFieldLanguage.value'
                          )}`}
                          id="description"
                          component={DraftEditor}
                          disableToolbar={true}
                          toolbarOnFocus={false}
                          containerStyle={{}}
                          editorClassname={'skin-res--editor'}
                        />
                      </div>
                    </div>
                  </div>
                  <h6>
                    <Trans i18nKey="p.s.uiconfiguration.getskinresult.send.button">
                      Send Button
                    </Trans>
                  </h6>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.button.text">
                        Button Text
                      </Trans>
                    </label>
                    <div
                      className="col-9  col-lg-8 col-md-8 row"
                      style={{display: width >= 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Select
                          options={langUtils.getAppLangList()}
                          onChange={o => {
                            formikProps.setFieldValue(
                              'featureConfig.getPhoto.email.sendButton.textLanguage',
                              o
                            );
                          }}
                          value={_get(
                            formikProps.values,
                            'featureConfig.getPhoto.email.sendButton.textLanguage'
                          )}
                          isSearchable={false}
                          isClearable={false}
                          placeholder={
                            <Trans i18nKey="c.c.select.placeholder">
                              Select...
                            </Trans>
                          }
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-6': width >= 1366,
                          'col-12': width < 1366,
                          'kt-margin-b-10': width < 1366,
                        })}
                      >
                        <Field
                          name={`featureConfig.getPhoto.email.sendButton.textI18n.${_get(
                            formikProps.values,
                            'featureConfig.getPhoto.email.sendButton.textLanguage.value'
                          )}`}
                          id="description"
                          placeholder={t(
                            'p.c.addrequest.description.placeholder',
                            'Please include detailed description of the issue or error message. If possible, please attach a screenshot.'
                          )}
                          component={DraftEditor}
                          toolbarOnFocus={true}
                          containerStyle={{}}
                          editorClassname={'skin-res--editor'}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.button.background">
                        Button Background
                      </Trans>
                    </label>
                    <div className={width >= 1366 ? 'col-4' : 'col-8'}>
                      <Field
                        name="featureConfig.getPhoto.email.sendButton.backgroundColor"
                        component={ColorField}
                      />
                    </div>
                  </div>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.button.border">
                        Button Border
                      </Trans>
                    </label>
                    <div
                      className="col-9 col-lg-8 col-md-8"
                      style={{display: width >= 1366 ? 'flex' : 'block'}}
                    >
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-9': width < 1366,
                          'kt-margin-b-20': width < 1366,
                        })}
                      >
                        <Field
                          name="featureConfig.getPhoto.email.sendButton.border.color"
                          component={ColorField}
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-9': width < 1366,
                          'kt-margin-b-20': width < 1366,
                        })}
                      >
                        <Field
                          name="featureConfig.getPhoto.email.sendButton.border.width"
                          component={SelectBox}
                          options={skinResultPageStyle.getBorderWidthConfigs()}
                        />
                      </div>
                      <div
                        className={classnames({
                          'col-3': width >= 1366,
                          'col-9': width < 1366,
                          'kt-margin-b-20': width < 1366,
                        })}
                      >
                        <Field
                          name="featureConfig.getPhoto.email.sendButton.border.style"
                          component={SelectBox}
                          options={skinResultPageStyle.getBorderStyleConfigs()}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className="form-group row"
                    style={{alignItems: 'center'}}
                  >
                    <label className="col-3 col-lg-4 col-md-4 col-form-label text-right">
                      <Trans i18nKey="p.s.uiconfiguration.getskinresult.button.radius">
                        Button Corner Radius
                      </Trans>
                    </label>
                    <div className="col-3">
                      <Field
                        name="featureConfig.getPhoto.email.sendButton.border.radius"
                        component={InputBox}
                        type="number"
                      />
                    </div>
                    <div className="d-flex" style={{margin: 'auto 0'}}>
                      px
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end kt-margin-t-20">
                  <ButtonWithRestoreGroup
                    saveDirty={formikProps.dirty}
                    discardButton={false}
                    isUpdating={true}
                    onRestoreClick={() => {
                      handleRestore(
                        _get(
                          formikProps.values,
                          'featureConfig.getPhoto.templateStyle'
                        )
                      );
                      formikProps.resetForm();
                    }}
                  />
                </div>
              </div>
            </div>
            {!isLoaded && !hidePreview && template && formikProps.values && (
              <div className="skincare-configuration-layout__right">
                <PreviewModule
                  values={formikProps.values}
                  template={{
                    ...template,
                    langs: [
                      {
                        default: template ? template.langs[0].default : true,
                        lang: template ? template.langs[0].langs : 'enu',
                        page: formikProps.values,
                        sharedPage: template
                          ? template.langs[0].sharedPage
                          : [],
                      },
                    ],
                  }}
                  previewUrl={previewUrl}
                  type={'GetResult'}
                  onChangeLanguage={lang => {
                    formikProps.setFieldValue(
                      'featureConfig.getPhoto.qrCode.title.textLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'featureConfig.getPhoto.qrCode.descLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'featureConfig.getPhoto.email.title.textLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'featureConfig.getPhoto.email.inputFieldLanguage',
                      lang
                    );
                    formikProps.setFieldValue(
                      'featureConfig.getPhoto.email.sendButton.textLanguage',
                      lang
                    );
                  }}
                  isV2Above={false}
                />
              </div>
            )}
            <UnSavedModal
              type={'theme'}
              showModal={showDialog}
              setShowModal={setShowDialog}
              handleLeave={() =>
                changeTheme(
                  theme,
                  formikProps.values,
                  formikProps.setValues,
                  formikProps.setFieldValue
                )
              }
              handleCancel={() => {
                formikProps.setFieldValue(
                  'featureConfig.getPhoto.templateStyle',
                  theme === 'dark' ? 'light' : 'dark'
                );
                setTheme(theme => (theme === 'dark' ? 'light' : 'dark'));
              }}
            />
          </div>
          <PublishToOnlineModal
            isShow={isShowPublishModal}
            onPublish={isPublish => {
              formikProps.setSubmitting(false);
              formikProps.resetForm(formikProps.values);
              setPublishStatus(isPublish);
              setIsShowPublishModal(false);
            }}
          />
        </Form>
      )}
    </Formik>
  );
}
